import React from 'react';

export type StatusType = 'pendiente' | 'facturaGenerada' | 'facturaEnviada' | 'descartado';

interface StatusTagProps {
  status: StatusType;
  className?: string;
}

const statusConfig: Record<StatusType, { text: string; bgColor: string }> = {
  pendiente: { text: 'Pendiente', bgColor: 'bg-[rgba(120,120,120,0.15)]' },
  facturaGenerada: { text: 'Listo', bgColor: 'bg-[rgba(39,146,66,0.19)]' },
  facturaEnviada: { text: 'Listo', bgColor: 'bg-[rgba(39,146,66,0.19)]' },
  descartado: { text: 'Descartado', bgColor: 'bg-[rgba(139,37,37,0.19)]' }
};

// Extended status types from backend (for backward compatibility)
const extendedStatusConfig: Record<string, { text: string; bgColor: string }> = {
  ...statusConfig, // facturaGenerada is now green, same as facturaEnviada
  'procesado': { text: 'Listo', bgColor: 'bg-[rgba(39,146,66,0.19)]' },
  'no-procesado': { text: 'Descartado', bgColor: 'bg-[rgba(139,37,37,0.19)]' },
  'completado': { text: 'Completado', bgColor: 'bg-[rgba(39,146,66,0.19)]' },
  'cancelado': { text: 'Cancelado', bgColor: 'bg-[rgba(139,37,37,0.19)]' },
  'confirmado': { text: 'Confirmado', bgColor: 'bg-[rgba(39,146,66,0.19)]' },
};

export const StatusTag: React.FC<StatusTagProps> = ({ status, className = '' }) => {
  const config = statusConfig[status] || extendedStatusConfig[status as string] || statusConfig['pendiente'];
  
  return (
    <div 
      className={`${config.bgColor} flex items-center justify-center px-2 py-0.5 rounded-full ${className}`}
      data-name="tag status de pedido" 
      data-node-id="1:158"
    >
      <p className="font-sans font-semibold text-xs text-status-text tracking-[-0.12px] whitespace-nowrap">
        {config.text}
      </p>
    </div>
  );
};

export default StatusTag;

